import React from "react";

import five_star_polish from "../../../static/images/svg/five-star-polish.svg";

export const OwnerStarBox = () => {
	return (
		<div className="note-five-star">
			<img loading="lazy" src={five_star_polish} alt="Chủ xe 5*" />
			<p>
				Chủ xe 5* có thời gian phản hồi nhanh chóng, tỉ lệ đồng ý cao, mức giá cạnh tranh & dịch vụ nhận được nhiều đánh
				giá tốt từ khách&nbsp;hàng.
			</p>
		</div>
	);
};

export const OwnerResponse = ({ owner }) => {
	return (
		<div className="owner-response">
			<div className="owner-response__item">
				<p>Tỉ lệ phản hồi</p>
				<p className="main">{owner.responseRate}</p>
			</div>
			<div className="owner-response__item">
				<p>Thời gian phản hồi</p>
				<p className="main">{owner.responseTime}</p>
			</div>
			<div className="owner-response__item">
				<p>Tỉ lệ đồng ý</p>
				<p className="main">{owner.acceptRate}</p>
			</div>
		</div>
	);
};
